/** Phase durations, in seconds of real time unless noted. */
export const TIMING = {
  boot: 5.2,
  welcome: 2.8,
  connect: 5.4,
  /** Point in the connect phase at which the uplink reports secure. */
  linkSecure: 3.7,
  accessGrantedHold: 1.2,
  accessDeniedHold: 0.9,
  /** Longer than a denial: the operator needs time to read that the service is down. */
  accessUnavailableHold: 2.4,
  countdown: 20,
  cycle: 600,
  /** Final seconds of the leave-the-room countdown that get the higher-pitched beep. */
  countdownFinalStretch: 5,
} as const;

/** Demo builds compress the countdown and cycle so a full run fits in a meeting. */
export const ACCELERATED_TIME_SCALE = { countdown: 4, cycle: 20 } as const;
export const REAL_TIME_SCALE = { countdown: 1, cycle: 1 } as const;
